<div class="app-container {{ bodyClass }} {{ viewportClass }}">
  <mat-drawer-container [hasBackdrop]="true" class="drawer-container">
    @if (isHandset$ | async) {
      <mat-drawer #drawer class="sidenav" fixedInViewport
        [attr.role]="'navigation'"
        [mode]="'over'"
        [opened]="false">
        <app-navigation [viewportClass]="(isHandset$ | async) ? handsetViewportClass : desktopViewportClass"></app-navigation>
      </mat-drawer>
    }
    <mat-drawer-content cdkScrollable (scroll)="onContainerScroll($event)">
      <!-- Toolbar -->
      <div class="toolbar" role="banner">
        <app-toolbar
          [title]="title"
          [isHandset]="isHandset$ | async"
          [viewportClass]="(isHandset$ | async) ? handsetViewportClass : desktopViewportClass"
          (menuToggle)="toggleMenu()">
        </app-toolbar>
      </div>
      @if (isLoggedIn) {
        <app-tenant-banner></app-tenant-banner>
      }
      <div #content class="content" role="main">
        <app-install-pwa-prompt
        ></app-install-pwa-prompt>
        <router-outlet></router-outlet>
        <!-- Footer -->
        <footer>
        </footer>
      </div>
      @if (isLoggedIn && (isHandset$ | async)) {
        <!-- Temporarily disabled footer toolbar for handset view -->
        <!-- <div class="toolbar footer" role="toolbar">
          <app-toolbar
            [isHandset]="isHandset$ | async"
            [viewportClass]="(isHandset$ | async) ? handsetViewportClass : desktopViewportClass"
            [mode]="'footer'"
            >
          </app-toolbar>
        </div> -->
      }
    </mat-drawer-content>
  </mat-drawer-container>
  <div class="background"></div>
</div>